import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {reducer as toastrReducer} from "react-redux-toastr";

const reducer = combineReducers({
    toastr: toastrReducer
})

const store = configureStore({reducer});

export default store;

export type RootState = ReturnType<typeof store.getState>